import { useEffect } from 'react';
import { analyticsService } from '../services';

interface GoogleAnalyticsProviderProps {
  measurementId: string;
  children: React.ReactNode;
}

/**
 * GoogleAnalyticsProvider component ensures that Google Analytics is properly loaded 
 * and provides a fallback mechanism in case react-ga4 fails to load.
 */
const GoogleAnalyticsProvider: React.FC<GoogleAnalyticsProviderProps> = ({ 
  measurementId, 
  children 
}) => {
  useEffect(() => {
    // Initialize analytics service
    analyticsService.init();
    
    // Fallback: If GA is not loaded after 3 seconds, inject the script manually
    const timeout = setTimeout(() => {
      if (!analyticsService.isLoaded()) {
        console.log('Fallback: Loading Google Analytics script directly');
        
        // Create the script elements
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        
        const inlineScript = document.createElement('script');
        inlineScript.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `;
        
        // Add scripts to document head
        document.head.appendChild(gtagScript);
        document.head.appendChild(inlineScript);
      }
    }, 3000);
    
    // Cleanup
    return () => clearTimeout(timeout);
  }, [measurementId]);
  
  return <>{children}</>;
};

export default GoogleAnalyticsProvider; 